// @flow
import React from 'react';
import TimeSpent from 'app/common/lib/react/TimeSpent';
import type { Filter } from 'app/common/react/components/profile/storefront/Filter/types';
import type { ProfileUser } from 'app/packages/pinterest-flow-types/user';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import withResource from 'app/common/lib/react/withResource';
import withViewer from 'app/common/lib/react/withViewer';
import { compose } from 'redux';
import { UserProfilePinGrid } from 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGrid';
import { Box, Toast } from 'gestalt';

type Props = {|
  filter?: Filter,
  handleToastText?: string,
  isGridCentered?: boolean,
  isOwnProfile: boolean,
  pins: {
    data: Array<Object>,
    fetchMore: () => void,
    isFetching: boolean,
    isLoaded: boolean,
    refreshData: () => void,
  },
  productGroupId?: string,
  productGroupType?: string,
  scrollContainer?: () => HTMLElement,
  user: ProfileUser,
  viewer: Viewer,
|};

function ProfileProductPins({
  isOwnProfile,
  isGridCentered = false,
  user,
  filter,
  pins,
  viewer,
  handleToastText,
  scrollContainer,
}: Props) {
  const timeSpentViewParam = isOwnProfile
    ? PCONST.thrift.ViewParameterType.USER_SELF
    : PCONST.thrift.ViewParameterType.USER_OTHERS;

  return (
    <Box>
      <TimeSpent
        view={PCONST.thrift.ViewType.USER}
        viewParameter={timeSpentViewParam}
        component={PCONST.thrift.ComponentType.USER_STOREFRONT}
      >
        <UserProfilePinGrid
          isOverview={false}
          isOwnProfile={isOwnProfile}
          user={user}
          username={user.username}
          pins={pins}
          viewer={viewer}
          isGridCentered={isGridCentered}
          scrollContainer={scrollContainer}
        />
      </TimeSpent>
      <Box
        fit
        dangerouslySetInlineStyle={{
          __style: {
            bottom: 50,
            left: '50%',
            transform: 'translateX(-50%)',
          },
        }}
        paddingX={1}
        position="fixed"
      >
        {pins.data && pins.data.length === 0 && handleToastText && <Toast text={handleToastText} />}
      </Box>
    </Box>
  );
}

export default compose(withViewer)(ProfileProductPins);

export const ProfileProductPinsWithResource = compose(
  withViewer,
  withResource({
    name: 'StoreFrontFeedResource',
    key: 'pins',
    options: (props) => {
      const base = {
        exclude_add_pin_rep: true,
        username: props.user.username,
        userId: props.user.id,
        filter: props.filter,
        field_set_key: 'grid_item',
      };
      if (props.productGroupId) {
        return Object.assign({}, base, { product_group_id: props.productGroupId });
      } else if (props.productGroupType) {
        return Object.assign({}, base, { product_group_type: props.productGroupType });
      } else {
        return base;
      }
    },
  }),
)(ProfileProductPins);
